export function createLookupWithCategory(config, category?: string) {
  return config.map(({ value, description }) => ({
    value: value,
    description: description ?? '',
    category: category ?? 'Other',
  }));
}
